<div class="research-question-item">
    <span class="research-question-text">
      <input type="checkbox"/>
      {{ question.mainQuestion }}</span>
</div>
